import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export const getSupplyRequests = (setSupplyRequests, dateFilters ,setChoferes) => {
    const startDate = dateFilters.start.value.toISOString().split('T')[0];
    const endDate = dateFilters.end.value.toISOString().split('T')[0];

    api.get(urlApi + `/administracion/getSupplyRequests?fecha_inicio=${startDate}&fecha_fin=${endDate}`).then((res) => {
        setSupplyRequests(res.data);
        const choferesUnicos = Array.from(
            new Set(res.data.map(record => record.CHOFER))
        );
        setChoferes(choferesUnicos);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const updateSupplyRequests = async (request) => {
    try {
        return api.put(urlApi + `/administracion/updateSupplyRequests`, request);
    } catch (e) {
        throw new Error(e);
    }
}

export const updateProducts = async (request) => {
    try {
        return api.put(urlApi + `/administracion/updateProducts`, request);
    } catch (e) {
        throw new Error(e);
    }
}
